import React, { useState } from 'react';
import {
  Button,
  IconButton,
  IconButtonProps,
  Popover,
  Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { TP_COLORS } from '../../constants';

const BUTTON_BG_COLOR = 'rgba(236, 236, 236, 0.1)';

const iconButtonStyles: IconButtonProps['style'] = {
  backgroundColor: BUTTON_BG_COLOR,
  borderRadius: '4px',
  marginLeft: '20px',
};

export interface IMenuButton {
  isDisabled: boolean;
  onClick: () => void;
}

const MenuButton: React.FC<IMenuButton> = ({ onClick, isDisabled }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'menu-popover' : undefined;

  return (
    <>
      <Tooltip title="Menu">
        <IconButton
          disabled={isDisabled}
          aria-describedby={id}
          size="small"
          onClick={handleClick}
          style={{ ...iconButtonStyles, opacity: isDisabled ? 0.5 : 1 }}
        >
          <MenuIcon style={{ color: TP_COLORS.white }} />
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{ marginTop: '5px' }}
      >
        <Button
          style={{ margin: '10px' }}
          color="inherit"
          variant="text"
          onClick={() => {
            onClick();
            handleClose();
          }}
        >
          + Add Questions
        </Button>
      </Popover>
    </>
  );
};

export default MenuButton;
